import { render, staticRenderFns } from "./LabelTable.vue?vue&type=template&id=3e16691b&scoped=true&"
import script from "./LabelTable.vue?vue&type=script&lang=js&"
export * from "./LabelTable.vue?vue&type=script&lang=js&"
import style0 from "./LabelTable.vue?vue&type=style&index=0&id=3e16691b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e16691b",
  null
  
)

export default component.exports